import { connect } from 'react-redux';
import type { SolveResultFormat } from 'state/quotes/results/result.model';
import {
  getFixedAmountInPercent,
  getFormQuoteDetails,
  getFormQuoteResult,
  getQuotePricerToBookingInvertedFlow,
  getQuoteRemunerationMode,
  getQuoteSolvingMode,
} from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

import type { FlowWay } from '../cashFlowWayUtils';
import { getQuoteFlowWay } from '../cashFlowWayUtils';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  solvingMode: string;
  isMultipleSolvingMode: boolean;
  solveResult: number;
  solveResultFormat?: SolveResultFormat;
  way: FlowWay;
  remunerationMode: string;
  fixedAmountInPercent: number;
}

export type QuotedNonTradableState = StateProps & OwnProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const solvingMode = getQuoteSolvingMode(state, tabId);
  const remunerationMode = getQuoteRemunerationMode(state, tabId);
  const quoteResult = getFormQuoteResult(state, workspaceType, tabId)!;
  const solveResult = quoteResult?.solveResult!;
  const solveResultFormat = quoteResult?.solveResultFormat;

  const pricerToBookingInvertedFlow = getQuotePricerToBookingInvertedFlow(state, workspaceType, tabId);
  const flowWay = getQuoteFlowWay(
    workspaceType,
    pricerToBookingInvertedFlow,
    solvingMode,
    remunerationMode,
    solveResult,
  );
  const quoteDetails = getFormQuoteDetails(state, workspaceType, tabId)!;
  const fixedAmountInPercent = getFixedAmountInPercent(state, tabId);

  return {
    solveResult,
    solveResultFormat,
    solvingMode,
    isMultipleSolvingMode: quoteDetails?.IsMultipleSolvingMode ?? false,
    way: flowWay,
    remunerationMode,
    fixedAmountInPercent,
  };
};

export const connectQuotedNonTradeable = connect(mapStateToProps);
